import _defineProperty from "/var/www/vhosts/thuisinaanbouw.nl/gatsby/thuisinaanbouw.nl/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from "react";
import { createModule } from "../config.js";
import { useContainerRect } from "../hooks/index.js";
import { clsx, composePrefix, cssClass, cssVar, isImageSlide, parseLengthPercentage } from "../utils.js";
import { ImageSlide } from "../components/index.js";
import { useController } from "./Controller.js";
import { useEvents } from "../contexts/Events.js";
import { useLightboxState } from "../contexts/LightboxState.js";
import { CLASS_FLEX_CENTER, CLASS_FULLSIZE, MODULE_CAROUSEL, YARL_EVENT_BACKDROP_CLICK } from "../consts.js";

var cssPrefix = function cssPrefix(value) {
  return composePrefix(MODULE_CAROUSEL, value);
};

var cssSlidePrefix = function cssSlidePrefix(value) {
  return composePrefix("slide", value);
};

var CarouselSlide = function CarouselSlide(_ref) {
  var slide = _ref.slide,
      offset = _ref.offset;

  var _useContainerRect = useContainerRect(),
      setContainerRef = _useContainerRect.setContainerRef,
      containerRect = _useContainerRect.containerRect,
      containerRef = _useContainerRect.containerRef;

  var _useEvents = useEvents(),
      publish = _useEvents.publish;

  var _useLightboxState = useLightboxState(),
      currentIndex = _useLightboxState.state.currentIndex;

  var _useController = useController(),
      getLightboxProps = _useController.getLightboxProps;

  var _getLightboxProps = getLightboxProps(),
      render = _getLightboxProps.render,
      imageFit = _getLightboxProps.carousel.imageFit,
      onClick = _getLightboxProps.on.click;

  var renderSlide = function renderSlide(rect) {
    var _a, _b, _c, _d;

    var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, slide, offset, rect);

    if (!rendered && isImageSlide(slide)) {
      rendered = React.createElement(ImageSlide, {
        slide: slide,
        offset: offset,
        render: render,
        rect: rect,
        imageFit: imageFit,
        onClick: offset === 0 ? function () {
          return onClick === null || onClick === void 0 ? void 0 : onClick(currentIndex);
        } : undefined
      });
    }

    return rendered ? React.createElement(React.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, slide), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function (_, x) {
      return x;
    })(slide, rendered), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, slide)) : null;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    var container = containerRef.current;
    var target = event.target instanceof HTMLElement ? event.target : undefined;

    if (target && container && (target === container || Array.from(container.children).find(function (x) {
      return x === target;
    }) && target.classList.contains(cssClass(CLASS_FULLSIZE)))) {
      publish(YARL_EVENT_BACKDROP_CLICK);
    }
  };

  return React.createElement("div", {
    ref: setContainerRef,
    className: clsx(cssClass(cssSlidePrefix()), offset === 0 && cssClass(cssSlidePrefix("current")), cssClass(CLASS_FLEX_CENTER)),
    onClick: handleBackdropClick
  }, containerRect && renderSlide(containerRect));
};

var Placeholder = function Placeholder() {
  return React.createElement("div", {
    className: cssClass("slide")
  });
};

export var Carousel = function Carousel(_ref2) {
  var _style;

  var slides = _ref2.slides,
      _ref2$carousel = _ref2.carousel,
      finite = _ref2$carousel.finite,
      preload = _ref2$carousel.preload,
      padding = _ref2$carousel.padding,
      spacing = _ref2$carousel.spacing;

  var _useLightboxState2 = useLightboxState(),
      _useLightboxState2$st = _useLightboxState2.state,
      currentIndex = _useLightboxState2$st.currentIndex,
      globalIndex = _useLightboxState2$st.globalIndex;

  var _useController2 = useController(),
      setCarouselRef = _useController2.setCarouselRef;

  var spacingValue = parseLengthPercentage(spacing);
  var paddingValue = parseLengthPercentage(padding);
  var items = [];

  if ((slides === null || slides === void 0 ? void 0 : slides.length) > 0) {
    for (var i = currentIndex - preload; i < currentIndex; i += 1) {
      var key = globalIndex + i - currentIndex;
      items.push(!finite || i >= 0 ? React.createElement(CarouselSlide, {
        key: key,
        slide: slides[(i + preload * slides.length) % slides.length],
        offset: i - currentIndex
      }) : React.createElement(Placeholder, {
        key: key
      }));
    }

    items.push(React.createElement(CarouselSlide, {
      key: globalIndex,
      slide: slides[currentIndex],
      offset: 0
    }));

    for (var _i = currentIndex + 1; _i <= currentIndex + preload; _i += 1) {
      var _key = globalIndex + _i - currentIndex;

      items.push(!finite || _i <= slides.length - 1 ? React.createElement(CarouselSlide, {
        key: _key,
        slide: slides[_i % slides.length],
        offset: _i - currentIndex
      }) : React.createElement(Placeholder, {
        key: _key
      }));
    }
  }

  return React.createElement("div", {
    ref: setCarouselRef,
    className: clsx(cssClass(cssPrefix()), items.length > 0 && cssClass(cssPrefix("with_slides"))),
    style: (_style = {}, _defineProperty(_style, "".concat(cssVar(cssPrefix("slides_count"))), items.length), _defineProperty(_style, "".concat(cssVar(cssPrefix("spacing_px"))), spacingValue.pixel || 0), _defineProperty(_style, "".concat(cssVar(cssPrefix("spacing_percent"))), spacingValue.percent || 0), _defineProperty(_style, "".concat(cssVar(cssPrefix("padding_px"))), paddingValue.pixel || 0), _defineProperty(_style, "".concat(cssVar(cssPrefix("padding_percent"))), paddingValue.percent || 0), _style)
  }, items);
};
export var CarouselModule = createModule(MODULE_CAROUSEL, Carousel);